<template>
  <div class="form-group">
    <label><v-icon>mdi-magnify</v-icon> </label>
    <v-text-field
      v-show="selectedType === 'Address'"
      label=""
      dense
      placeholder="Enter an address"
      id="search-input"
      ref="addressBox"
      v-model="addressString"
    ></v-text-field>
  </div>
</template>
<script>
import { Loader } from "google-maps";
import { EventBus } from "../../js/DataManagement/EventBus";
export default {
  name: "AddressSearch",
  components: {},
  data: function () {
    return {
      searchBox: null,
      addressString: "",
      windowWidth: window.innerWidth,
      selectedType: "Address",
      searchType: [{ text: "Address", value: "Address" }],
    };
  },
  mounted: function () {
    if (typeof google === "undefined") this.init();

    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });

    EventBus.$on("change-search", (val) => (this.selectedType = val));
    EventBus.$on("clearAddress", () => {
      this.addressString = "";
    });
  },
  watch: {
    selectedAddress: function (val) {
      if (typeof val.name === "undefined" || !val.name) {
        this.addressString = "";
      }
    },
    selectedType: function () {},
  },
  computed: {},
  methods: {
    setSearchBounds() {
      if (this.searchBox) {
        this.searchBox.setBounds();
      }
    },
    async init() {
      const loader = new Loader(this.$mainConfig.api.keys.GoogleKey, {
        libraries: ["places"],
      });

      const google = await loader.load();
      const input = document.getElementById("search-input");

      this.searchBox = new google.maps.places.Autocomplete(input, {
        bounds: this.$mainConfig.addressSearchBounds,
        componentRestrictions: { country: "us" },
      });
      let self = this;
      this.searchBox.addListener("place_changed", () => {
        const place = this.searchBox.getPlace();

        if (!place) return;
        const loc = place.geometry.location;
        const lnglat = [loc.lng(), loc.lat()];
        self.$store.commit("setSelectedLngLat",lnglat);

        EventBus.$emit("select-from-address-search", lnglat);
      });
    },
  },
};
</script>
<style scoped>
.v-toolbar .v-input {
  margin-top: 10%;
  display: inline-block;
  width: 95%;
  caret-color: black;
}
#app div.side-top > div > div.form-group > div {
  display: inline-block;
  width: 85%;
}
.district-type-selector {
  max-width: 210px;
}

.form-group {
  white-space: nowrap;
}
</style>